import { BackIcon } from "components/Icons";
import { Button, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IHeaderProps } from "../../interfaces/General/IHeaderProps";
import styles from "./PageHeader.module.css";

const PageHeader = ({ title, spanBtn, linkBtns, backLink }: IHeaderProps) => {
  return (
    <>
      <div className={styles.pageHeader}>
        <Stack direction="vertical" gap={4}>
          <div className="flex flex-row justify-between">
            <div className="flex flex-row items-center gap-2">
              {backLink && (
                <Link to={backLink}>
                  <BackIcon />
                </Link>
              )}
              <h1 className="text-heading-1">{title}</h1>
            </div>

            <div className="flex flex-row gap-2 items-center ">
              <Button
                className="order-last"
                onClick={spanBtn.onClick}
                variant="primary"
                disabled={spanBtn.disabled}
              >
                {spanBtn.text}
              </Button>
            </div>
          </div>
          {linkBtns && (
            <div className="flex flex-row items-center gap-10">
              {linkBtns.map((btn) => (
                <Button
                  key={btn.text}
                  variant="link-1"
                  onClick={btn.onClick}
                  disabled={btn.disabled}
                >
                  {btn.text}
                </Button>
              ))}
            </div>
          )}
        </Stack>
      </div>
    </>
  );
};

export default PageHeader;
